export default "__VITE_ASSET__480aca1d__"